import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToolbarComponent } from "./toolbar.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule } from "@ngx-translate/core";
import { VersionModule } from "../../../../shared/components/version/version.module";
@NgModule({
  declarations: [
    ToolbarComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule, MatSelectModule, MatMenuModule,
    TranslateModule,
    VersionModule
  ],
  exports: [
    ToolbarComponent
  ]
})
export class ToolbarModule { }
